<template>
    <div class="flex items-center justify-between w-full gap-8 px-8 py-4 bg-black rounded-t-lg md:rounded-t-2xl">

      <button v-if="hasGalleryItems" @click.prevent="$emit('view-gallery')" class="w-16 rounded-md cursor-pointer ring-4 ring-transparent hover:ring-white hover:bg-gray-100" >
        <img :src="latestGalleryItem.thumbnail" class="flex-none object-cover object-center w-16 h-12 bg-gray-100 rounded-md">
      </button>
      <div v-else class="w-16">
      </div>

      <button v-if="captureAvailable" @click.prevent="requestCapture" type="button" class="inline-flex items-center p-6 text-2xl text-white bg-indigo-600 border border-transparent rounded-full shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        <i class="fas fa-camera fa-xl"></i>
      </button>
      <button v-else type="button" class="inline-flex items-center p-6 text-2xl text-white bg-indigo-500 border border-transparent rounded-full shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        <i class="fas fa-spinner fa-spin fa-xl"></i>
      </button>

      <div class="w-16 text-gray-400 cursor-pointer hover:text-white" @click.prevent="onExit">
        <i class="far fa-times-circle fa-2x"></i>
      </div>

    </div>
</template>
<script>
export default {
  props: {
    gallery: {
      type: Array,
      default:() => []
    }
  },

  data () {
    return {
      captureAvailable: true
    }
  },

  computed: {
    hasGalleryItems () {
      return this.gallery.length > 0
    },

    latestGalleryItem () {
      if(!this.hasGalleryItems) return null 

      return this.gallery[this.gallery.length - 1]
    }
  },


  methods: {

    onExit () {
       if (window.confirm('Are you sure want to exit?')) {
          window.location.href = '/'
          return false
        }
    },

    requestCapture () {
      if(!this.captureAvailable) return

      this.captureAvailable = false
      this.$emit('capture')
      setTimeout(() => { this.captureAvailable = true }, 1000)
    }
  }
}
</script>
